<template>
	<div>

		<div v-scroll="onScroll">

			<div full-width class="search-filter two-btn">
		    	<v-text-field elevation-10  flat solo clearable placeholder="Search..." v-model="searchValue" @input="fn_searchItem" class="search-box" hide-details :class="{'bottom-shadow':scrollPositionTop!=0}"></v-text-field>

		    	<div v-ripple class="filter-btn" @click="add">
		    		<v-icon>add</v-icon>
		    	</div>
		    	
		    	<div v-ripple class="filter-btn" @click="fn_openDialogFilterItems">
		    		<v-icon>filter_list</v-icon>
		    		<span style="font-size: 48px;position: absolute;bottom: -6px;right: 6px;color: #4b77be;" v-if="selectedFilterItemValue != null || selectedSortValue">&bull;</span>
		    	</div>

		    </div>


			<div style="clear:both">

				<v-list grey-back three-line nopadding>

					<div white-background v-for="(item, index) in listItemObject.items" :key="index" :class="{'margin-top-ten':index!=0}" :id="'item_'+item.productId">
						<v-list-tile v-ripple @click="fn_itemClick(item.productId, index)">

						    <v-list-tile-content>
						      	<v-list-tile-title class="mb-1">{{item.productName}}</v-list-tile-title>
						      	<v-list-tile-sub-title dark-opacity-color>
						      		Purchase Rate: &#8377; {{item.purchasePrice ? $root.numberToLocale(roundUpto2Decimals(item.purchasePrice)) : '0'}}
						      	</v-list-tile-sub-title>

						      	<v-list-tile-sub-title dark-opacity-color>
						      		Sale Price: &#8377; {{item.sellingPrice ? $root.numberToLocale(roundUpto2Decimals(item.sellingPrice)) : '0'}}
						      	</v-list-tile-sub-title>

								<v-chip small v-if="item.status == 0">De-Activated</v-chip>

						    </v-list-tile-content>

						    <v-list-tile-action style="padding:10px 0px">
							    <div></div>

						    	<div :class="{'redcolor': item.currentStock <= 0}">
						    		{{item.currentStock ? item.currentStock : 0}} {{item.unitName}}
						    	</div>
				            	
				            </v-list-tile-action>

						</v-list-tile>

						<v-divider></v-divider>
						<div right-align style="padding:2px 6px">
					    	<v-btn nomargin icon flat @click="fn_adjustStock('plus', item.productId, index)"><v-icon font20>add_circle_outline</v-icon></v-btn>
					    	<v-btn nomargin icon flat @click="fn_adjustStock('minus', item.productId, index)"><v-icon font20>remove_circle_outline</v-icon></v-btn>
					    </div>

					</div>


				</v-list>
				
				<transition name="fade" mode="out-in">
					<v-card noshadow class="create-placeholder-card" v-if="showPlaceHolder && !listItemObject.totalCount">
						<v-card-text @click="add">

							<div center-align>
				            	<div v-ripple class="placeholder-icon">
				            		<i aria-hidden="true" class="v-icon material-icons add-icon">add</i>
				            		<img src="../../../assets/icon_category.svg" alt="">
				            	</div><br>

				            	<p class="title light-opacity-color">Create New Item</p>
				            </div>
						</v-card-text>
					</v-card>

<!-- 					<v-card noshadow v-if="showPlaceHolder && !listItemObject.totalCount" style="height: calc(100vh - 104px);display: flex;align-items: center;">
						<v-card-text>

							<div center-align>
				            	<div @click="add" v-ripple style="width: 68px;height: 68px;border-radius: 50%;background: #F0F0F0;margin: auto;padding: 12px;position:relative">
				            		<i aria-hidden="true" class="v-icon material-icons" style="position: absolute;top: 0;right: 0px;background: #4b77be !important;border-radius: 50%;color: #fff !important;font-size: 20px;">add</i>
				            		<img src="../../../assets/icon_category.svg" style="opacity:0.6;width:42px" alt="">
				            	</div><br>

				            	<p class="title light-opacity-color" style="line-height:28px !important">Create New Item</p>
				            </div>

						</v-card-text>
					</v-card> -->
				</transition>
			</div>

		</div>	

		<dialog-filter-items ref="ref_dialogFilterItems" type="Items" :filterData="filterData" :setFilter="fn_setFilter" :selectedFilterItemValue="selectedFilterItemValue" :selectedSortValue="selectedSortValue" :deactivatedOnly="showOnlyDeactivated"></dialog-filter-items>


	</div>
</template>

<script>
var tagId = null;
const menuItem = require('../../../config.js').configs.menuItem;
const bottomSheetMenu = require('../../../config.js').configs.bottomSheetMenu;

import dialogFilterItems from '../dialogs/dialog_filter';

	export default{
		props:['add'],
		components: {
		    'dialog-filter-items': dialogFilterItems,
		},
		data(){
			return{
				listItemObject:{"items":[], "totalCount":0},
				searchValue:'',
				startIndex:0,
				scrollPositionTop:0,
				selectedItemId:null,
				filterData:{
					filterItems:[
						{"filterItemId":1, "name":"All", "value":null},
						{"filterItemId":2, "name":"In Stock", "value":1},
						{"filterItemId":3, "name":"Not In Stock", "value":0}
					],
					sortItems:[
						{"sortId":1, "name":"Item Name", "value":0},
						{"sortId":2, "name":"Stock - High to Low", "value":1},
						{"sortId":3, "name":"Stock - Low to High", "value":2}
					],
				},
				selectedFilterItemValue:null,
				selectedSortValue:0,
				loadMore:false,
				showPlaceHolder:false,
				showOnlyDeactivated:false
			}
		},
		methods:{

			fn_adjustStock(type, productId, index){
				let obj = {};
				obj.itemId = null;
				obj.lastScrollPos = window.pageYOffset;
				obj.itemIndex = index + 1;
				localStorage.setItem("activity_items_state", JSON.stringify(obj));

				this.$router.push({path:"/transactions/inventory/stockadjustment/items/new", query:{tagId:this.guidWeb(), type:type, itemid:productId}});
			},

			onScroll: function(event){
				var element = event.target;
			    if (element.documentElement.scrollHeight - element.documentElement.scrollTop - 150 <= element.documentElement.clientHeight)
			    {
			        console.log('scrolled');
			        if(this.listItemObject.items.length < this.listItemObject.totalCount){
			        	this.fn_loadItems();
			        }
			    }
			},

			fn_setFilter: function(filterItemId, sortId, showDeactivated){
				this.selectedFilterItemValue = filterItemId;
				this.selectedSortValue = sortId;
				this.showOnlyDeactivated = showDeactivated;

				let obj = {};
				obj.filterItemId = filterItemId;
				obj.sortId = sortId;
				obj.showOnlyDeactivated = showDeactivated;
				localStorage.setItem('activity_item_filter', JSON.stringify(obj));
				this.fn_closeDialog();
				this.fn_searchItem();
			},

			fn_openDialogFilterItems: function(){
				this.$refs['ref_dialogFilterItems'].openDialogWeb();
			},

			fn_closeDialog: function(){
				this.$refs['ref_dialogFilterItems'].dialog_filter_items = false;
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='edit'){
					this.$router.push('/transactions/sales/'+this.toolbarTitle.toLowerCase().replace(/ /g,'')+'/items/'+this.selectedItemId+'/edit');
				}
				else if(menuAction=='copy'){
					this.$router.push({path:"/transactions/sales/"+this.toolbarTitle.toLowerCase().replace(/ /g,'')+"/items/new", query:{tagId:this.guidWeb(), itemId:this.selectedItemId, copy:true}});
				}
			},

			fn_itemClick: function (itemId, index) {
				let obj = {};
				obj.itemId = null;
				obj.lastScrollPos = window.pageYOffset;
				obj.itemIndex = index + 1;
				localStorage.setItem("activity_items_state", JSON.stringify(obj));

				this.$router.push('/masters/inventory/productandservices/items/'+itemId);
			},

			fn_loadItems: function() {
				this.loadMore = true;
		    	let filterObject = {};
				filterObject.limit = 50;
				filterObject.startIndex = this.startIndex;
				filterObject.search = this.searchValue ? this.searchValue.toLowerCase() : '';

				if(localStorage.getItem('activity_item_filter')){
					let data = JSON.parse(localStorage.getItem('activity_item_filter'));
					this.selectedFilterItemValue = data.filterItemId;
					this.selectedSortValue = data.sortId;
					this.showOnlyDeactivated = data.showOnlyDeactivated ? data.showOnlyDeactivated : false;
				}

				filterObject.stockType = this.selectedFilterItemValue;
				filterObject.sortByStock = this.selectedSortValue;
				filterObject.showOnlyDeactivated = this.showOnlyDeactivated

				let pageState = null;
				if(localStorage.getItem("activity_items_state")){
					pageState = JSON.parse(localStorage.getItem("activity_items_state"));
					filterObject.limit = 50 - (pageState.itemIndex % 50) + pageState.itemIndex;
				}

				let self = this;
				this.getItems("InventoryItemList", filterObject, 
					{
						onSuccess: function (response) {
							console.log(response);
							let responseJson = JSON.parse(response);
							self.listItemObject.totalCount = responseJson.totalCount;

							for(let i in responseJson.items){
								let itemIndex = self.listItemObject.items.findIndex(item => item.productId==responseJson.items[i].productId);

								if(itemIndex==-1){
									self.listItemObject.items.push(responseJson.items[i]);	
								}
							}

							console.log(pageState);
							if(pageState && pageState.itemId){
								setTimeout(function(){
									let scrollOptions = {"duration":0, "offset":-56, "easing":"linear"};
									self.$vuetify.goTo('#item_'+pageState.itemId, scrollOptions);
									localStorage.removeItem("activity_items_state");
								},100);
							}

							if(pageState && !pageState.itemId){
								setTimeout(function(){
									let scrollOptions = {"duration":300, "offset":-56, "easing":"linear"};
									self.$vuetify.goTo(pageState.lastScrollPos, scrollOptions);
									localStorage.removeItem("activity_items_state");
								},100);
							}

							self.startIndex = self.listItemObject.items.length;
							self.loadMore = false;

							setTimeout(function(){
								self.showPlaceHolder = true;
							},300);
						},
						onError: function (error) {
							console.log(error);
							self.loadMore = false;
						}
					}
				)
		    },

		    fn_searchItem: function () {
				this.startIndex = 0;
				this.listItemObject.items = [];
				this.fn_loadItems();
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/activity/contents/items.vue